module.exports = [
  { code: "ab", label: "Abkhazian" },
  { code: "aa", label: "Afar" },
  { code: "af", label: "Afrikaans" },
  { code: "ak", label: "Akan" },
  { code: "sq", label: "Albanian" },
  { code: "am", label: "Amharic" },
  { code: "ar", label: "Arabic" },
  { code: "an", label: "Aragonese" },
  { code: "hy", label: "Armenian" },
  { code: "as", label: "Assamese" },
  { code: "av", label: "Avaric" },
  { code: "ae", label: "Avestan" },
  { code: "ay", label: "Aymara" },
  { code: "az", label: "Azerbaijani" },
  { code: "bm", label: "Bambara" },
  { code: "ba", label: "Bashkir" },
  { code: "eu", label: "Basque" },
  { code: "be", label: "Belarusian" },
  { code: "bn", label: "Bengali" },
  { code: "bh", label: "Bihari languages" },
  { code: "bi", label: "Bislama" },
  { code: "bs", label: "Bosnian" },
  { code: "br", label: "Breton" },
  { code: "bg", label: "Bulgarian" },
  { code: "my", label: "Burmese" },
  { code: "ca", label: "Catalan, Valencian" },
  { code: "km", label: "Central Khmer" },
  { code: "ch", label: "Chamorro" },
  { code: "ce", label: "Chechen" },
  { code: "ny", label: "Chichewa, Chewa, Nyanja" },
  { code: "zh", label: "Chinese" },
  { code: "cu", label: "Church Slavonic, Old Bulgarian, Old Church Slavonic" },
  { code: "cv", label: "Chuvash" },
  { code: "kw", label: "Cornish" },
  { code: "co", label: "Corsican" },
  { code: "cr", label: "Cree" },
  { code: "hr", label: "Croatian" },
  { code: "cs", label: "Czech" },
  { code: "da", label: "Danish" },
  { code: "dv", label: "Divehi, Dhivehi, Maldivian" },
  { code: "nl", label: "Dutch, Flemish" },
  { code: "dz", label: "Dzongkha" },
  { code: "en", label: "English" },
  { code: "eo", label: "Esperanto" },
  { code: "et", label: "Estonian" },
  { code: "ee", label: "Ewe" },
  { code: "fo", label: "Faroese" },
  { code: "fj", label: "Fijian" },
  { code: "fi", label: "Finnish" },
  { code: "fr", label: "French" },
  { code: "ff", label: "Fulah" },
  { code: "gd", label: "Gaelic, Scottish Gaelic" },
  { code: "gl", label: "Galician" },
  { code: "lg", label: "Ganda" },
  { code: "ka", label: "Georgian" },
  { code: "de", label: "German" },
  { code: "ki", label: "Gikuyu, Kikuyu" },
  { code: "el", label: "Greek (Modern)" },
  { code: "kl", label: "Greenlandic, Kalaallisut" },
  { code: "gn", label: "Guarani" },
  { code: "gu", label: "Gujarati" },
  { code: "ht", label: "Haitian, Haitian Creole" },
  { code: "ha", label: "Hausa" },
  { code: "he", label: "Hebrew" },
  { code: "hz", label: "Herero" },
  { code: "hi", label: "Hindi" },
  { code: "ho", label: "Hiri Motu" },
  { code: "hu", label: "Hungarian" },
  { code: "is", label: "Icelandic" },
  { code: "io", label: "Ido" },
  { code: "ig", label: "Igbo" },
  { code: "id", label: "Indonesian" },
  {
    code: "ia",
    label: "Interlingua (International Auxiliary Language Association)",
  },
  { code: "ie", label: "Interlingue" },
  { code: "iu", label: "Inuktitut" },
  { code: "ik", label: "Inupiaq" },
  { code: "ga", label: "Irish" },
  { code: "it", label: "Italian" },
  { code: "ja", label: "Japanese" },
  { code: "jv", label: "Javanese" },
  { code: "kn", label: "Kannada" },
  { code: "kr", label: "Kanuri" },
  { code: "ks", label: "Kashmiri" },
  { code: "kk", label: "Kazakh" },
  { code: "rw", label: "Kinyarwanda" },
  { code: "kv", label: "Komi" },
  { code: "kg", label: "Kongo" },
  { code: "ko", label: "Korean" },
  { code: "kj", label: "Kwanyama, Kuanyama" },
  { code: "ku", label: "Kurdish" },
  { code: "ky", label: "Kyrgyz" },
  { code: "lo", label: "Lao" },
  { code: "la", label: "Latin" },
  { code: "lv", label: "Latvian" },
  { code: "lb", label: "Letzeburgesch, Luxembourgish" },
  { code: "li", label: "Limburgish, Limburgan, Limburger" },
  { code: "ln", label: "Lingala" },
  { code: "lt", label: "Lithuanian" },
  { code: "lu", label: "Luba-Katanga" },
  { code: "mk", label: "Macedonian" },
  { code: "mg", label: "Malagasy" },
  { code: "ms", label: "Malay" },
  { code: "ml", label: "Malayalam" },
  { code: "mt", label: "Maltese" },
  { code: "gv", label: "Manx" },
  { code: "mi", label: "Maori" },
  { code: "mr", label: "Marathi" },
  { code: "mh", label: "Marshallese" },
  { code: "ro", label: "Moldovan, Moldavian, Romanian" },
  { code: "mn", label: "Mongolian" },
  { code: "na", label: "Nauru" },
  { code: "nv", label: "Navajo, Navaho" },
  { code: "nd", label: "Northern Ndebele" },
  { code: "ng", label: "Ndonga" },
  { code: "ne", label: "Nepali" },
  { code: "se", label: "Northern Sami" },
  { code: "no", label: "Norwegian" },
  { code: "nb", label: "Norwegian Bokmål" },
  { code: "nn", label: "Norwegian Nynorsk" },
  { code: "ii", label: "Nuosu, Sichuan Yi" },
  { code: "oc", label: "Occitan (post 1500)" },
  { code: "oj", label: "Ojibwa" },
  { code: "or", label: "Oriya" },
  { code: "om", label: "Oromo" },
  { code: "os", label: "Ossetian, Ossetic" },
  { code: "pi", label: "Pali" },
  { code: "pa", label: "Panjabi, Punjabi" },
  { code: "ps", label: "Pashto, Pushto" },
  { code: "fa", label: "Persian" },
  { code: "pl", label: "Polish" },
  { code: "pt", label: "Portuguese" },
  { code: "qu", label: "Quechua" },
  { code: "rm", label: "Romansh" },
  { code: "rn", label: "Rundi" },
  { code: "ru", label: "Russian" },
  { code: "sm", label: "Samoan" },
  { code: "sg", label: "Sango" },
  { code: "sa", label: "Sanskrit" },
  { code: "sc", label: "Sardinian" },
  { code: "sr", label: "Serbian" },
  { code: "sn", label: "Shona" },
  { code: "sd", label: "Sindhi" },
  { code: "si", label: "Sinhala, Sinhalese" },
  { code: "sk", label: "Slovak" },
  { code: "sl", label: "Slovenian" },
  { code: "so", label: "Somali" },
  { code: "st", label: "Sotho, Southern" },
  { code: "nr", label: "South Ndebele" },
  { code: "es", label: "Spanish, Castilian" },
  { code: "su", label: "Sundanese" },
  { code: "sw", label: "Swahili" },
  { code: "ss", label: "Swati" },
  { code: "sv", label: "Swedish" },
  { code: "tl", label: "Tagalog" },
  { code: "ty", label: "Tahitian" },
  { code: "tg", label: "Tajik" },
  { code: "ta", label: "Tamil" },
  { code: "tt", label: "Tatar" },
  { code: "te", label: "Telugu" },
  { code: "th", label: "Thai" },
  { code: "bo", label: "Tibetan" },
  { code: "ti", label: "Tigrinya" },
  { code: "to", label: "Tonga (Tonga Islands)" },
  { code: "ts", label: "Tsonga" },
  { code: "tn", label: "Tswana" },
  { code: "tr", label: "Turkish" },
  { code: "tk", label: "Turkmen" },
  { code: "tw", label: "Twi" },
  { code: "ug", label: "Uighur, Uyghur" },
  { code: "uk", label: "Ukrainian" },
  { code: "ur", label: "Urdu" },
  { code: "uz", label: "Uzbek" },
  { code: "ve", label: "Venda" },
  { code: "vi", label: "Vietnamese" },
  { code: "vo", label: "Volap_k" },
  { code: "wa", label: "Walloon" },
  { code: "cy", label: "Welsh" },
  { code: "fy", label: "Western Frisian" },
  { code: "wo", label: "Wolof" },
  { code: "xh", label: "Xhosa" },
  { code: "yi", label: "Yiddish" },
  { code: "yo", label: "Yoruba" },
  { code: "za", label: "Zhuang, Chuang" },
  { code: "zu", label: "Zulu" },
];
